// removed by extract-text-webpack-plugin
module.exports = {"bannerContainer":"nmAz_-M7GEP9x9mQ3uHVS","title":"_2Lvs3dPOjajSHhA9cx1V1Y","content":"_17GNvIGl3keqRgYKvrW4Ut","logo":"_2I-Ltpz99Xun_j2taAK8P9","description":"_12JjyPjSo2WFgSmTsmXE49","label":"_2Evci6zH4wFBteo8SbudAO","message":"_323tE5PkK0eHJSNBXL6EQ-","success":"GsY7Xmbgfw0gW3UJAIi1","error":"_23x4ZjvFa03_tCibjYNkh0"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MortgageBanner/MortgageBanner.scss
// module id = 1828
// module chunks = 0